import React from "react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Uses window.location.origin dynamically so the user always returns to the exact host they came from.
export default function GoogleSignInButton({ label = "Continue with Google", testId = "google-signin-btn" }) {
  const onClick = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-full bg-white text-ink font-bold text-sm uppercase tracking-widest hover:bg-white/90 transition-colors">
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.44a5.5 5.5 0 01-2.39 3.61v3h3.86c2.26-2.09 3.58-5.17 3.58-8.85z" />
        <path fill="#34A853" d="M12 24c3.24 0 5.96-1.08 7.95-2.92l-3.86-3c-1.07.72-2.44 1.14-4.09 1.14-3.15 0-5.82-2.12-6.77-4.99H1.24v3.13A11.99 11.99 0 0012 24z" />
        <path fill="#FBBC05" d="M5.23 14.23A7.19 7.19 0 014.85 12c0-.78.13-1.54.38-2.23V6.64H1.24A11.98 11.98 0 000 12c0 1.94.47 3.78 1.24 5.36l3.99-3.13z" />
        <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0A11.99 11.99 0 001.24 6.64l3.99 3.13C6.18 6.87 8.85 4.75 12 4.75z" />
      </svg>
      {label}
    </button>
  );
}
